import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { motion } from "framer-motion";

export default function ThemeToggle() {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const root = window.document.documentElement;
    if (theme === "light") {
      root.classList.add("light");
    } else {
      root.classList.remove("light");
    }
  }, [theme]);

  return (
    <button
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      className="relative h-8 w-14 rounded-full bg-white/10 border border-white/10 flex items-center px-1 shadow-inner overflow-hidden"
    >
      <div className="absolute inset-0 bg-black/20 pointer-events-none" />
      <motion.div
        layout
        className="h-6 w-6 rounded-full bg-white shadow-md flex items-center justify-center text-[var(--nily-teal)] z-10"
        animate={{ x: theme === "light" ? 24 : 0 }}
        transition={{ type: "spring", stiffness: 500, damping: 30 }}
      >
        {theme === "light" ? <Sun size={14} /> : <Moon size={14} />}
      </motion.div>
    </button>
  );
}
